import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { subYears } from 'date-fns';

// The date-fns adapter needed to be modified to allow years to display
// descending instead of ascending.
// Thus, AdapterDateFns is being imported and passed into a new function
// while the getYearRange function contained therein is modified to swap
// the displayed order of the dates.
export default function ModifiedAdapterDateFns(options) {
  const adapter = new AdapterDateFns(options);

  return {
    ...adapter,
    getYearRange(start, end) {
      const startDate = adapter.endOfYear(end);
      const endDate = adapter.startOfYear(start);
      const years = [];

      let current = startDate;
      while (adapter.isAfter(current, endDate)) {
        years.push(current);
        current = subYears(current, 1);
      }

      return years;
    },
  };
}
